module.exports = __webpack_public_path__ + "static/media/zheng8@2x.2a489109.png";